/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { utils, Contract, ContractFactory } from "ethers";
const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "_mailbox",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "_hook",
                type: "address",
            },
        ],
        name: "HookSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8",
            },
        ],
        name: "Initialized",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint32",
                name: "origin",
                type: "uint32",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "owner",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "address",
                name: "ism",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "InterchainAccountCreated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "_ism",
                type: "address",
            },
        ],
        name: "IsmSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint32",
                name: "destination",
                type: "uint32",
            },
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "router",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "ism",
                type: "bytes32",
            },
        ],
        name: "RemoteCallDispatched",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint32",
                name: "domain",
                type: "uint32",
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "ism",
                type: "bytes32",
            },
        ],
        name: "RemoteIsmEnrolled",
        type: "event",
    },
    {
        inputs: [],
        name: "PACKAGE_VERSION",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "accountOwners",
        outputs: [
            {
                internalType: "uint32",
                name: "origin",
                type: "uint32",
            },
            {
                internalType: "bytes32",
                name: "owner",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint32",
                name: "_destination",
                type: "uint32",
            },
            {
                internalType: "address",
                name: "_to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_value",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "_data",
                type: "bytes",
            },
        ],
        name: "callRemote",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint32",
                name: "_destination",
                type: "uint32",
            },
            {
                components: [
                    {
                        internalType: "bytes32",
                        name: "to",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint256",
                        name: "value",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes",
                        name: "data",
                        type: "bytes",
                    },
                ],
                internalType: "struct CallLib.Call[]",
                name: "_calls",
                type: "tuple[]",
            },
            {
                internalType: "bytes",
                name: "_hookMetadata",
                type: "bytes",
            },
        ],
        name: "callRemote",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint32",
                name: "_destination",
                type: "uint32",
            },
            {
                components: [
                    {
                        internalType: "bytes32",
                        name: "to",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint256",
                        name: "value",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes",
                        name: "data",
                        type: "bytes",
                    },
                ],
                internalType: "struct CallLib.Call[]",
                name: "_calls",
                type: "tuple[]",
            },
        ],
        name: "callRemote",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint32",
                name: "_destination",
                type: "uint32",
            },
            {
                internalType: "address",
                name: "_to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_value",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "_data",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "_hookMetadata",
                type: "bytes",
            },
        ],
        name: "callRemote",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint32",
                name: "_destination",
                type: "uint32",
            },
            {
                internalType: "bytes32",
                name: "_router",
                type: "bytes32",
            },
            {
                internalType: "bytes32",
                name: "_ism",
                type: "bytes32",
            },
            {
                components: [
                    {
                        internalType: "bytes32",
                        name: "to",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint256",
                        name: "value",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes",
                        name: "data",
                        type: "bytes",
                    },
                ],
                internalType: "struct CallLib.Call[]",
                name: "_calls",
                type: "tuple[]",
            },
        ],
        name: "callRemoteWithOverrides",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint32",
                name: "_destination",
                type: "uint32",
            },
            {
                internalType: "bytes32",
                name: "_router",
                type: "bytes32",
            },
            {
                internalType: "bytes32",
                name: "_ism",
                type: "bytes32",
            },
            {
                components: [
                    {
                        internalType: "bytes32",
                        name: "to",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint256",
                        name: "value",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes",
                        name: "data",
                        type: "bytes",
                    },
                ],
                internalType: "struct CallLib.Call[]",
                name: "_calls",
                type: "tuple[]",
            },
            {
                internalType: "bytes",
                name: "_hookMetadata",
                type: "bytes",
            },
        ],
        name: "callRemoteWithOverrides",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [],
        name: "domains",
        outputs: [
            {
                internalType: "uint32[]",
                name: "",
                type: "uint32[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint32",
                name: "_domain",
                type: "uint32",
            },
            {
                internalType: "bytes32",
                name: "_router",
                type: "bytes32",
            },
        ],
        name: "enrollRemoteRouter",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint32",
                name: "_destination",
                type: "uint32",
            },
            {
                internalType: "bytes32",
                name: "_router",
                type: "bytes32",
            },
            {
                internalType: "bytes32",
                name: "_ism",
                type: "bytes32",
            },
        ],
        name: "enrollRemoteRouterAndIsm",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint32[]",
                name: "_destinations",
                type: "uint32[]",
            },
            {
                internalType: "bytes32[]",
                name: "_routers",
                type: "bytes32[]",
            },
            {
                internalType: "bytes32[]",
                name: "_isms",
                type: "bytes32[]",
            },
        ],
        name: "enrollRemoteRouterAndIsms",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint32[]",
                name: "_domains",
                type: "uint32[]",
            },
            {
                internalType: "bytes32[]",
                name: "_addresses",
                type: "bytes32[]",
            },
        ],
        name: "enrollRemoteRouters",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint32",
                name: "_origin",
                type: "uint32",
            },
            {
                internalType: "address",
                name: "_owner",
                type: "address",
            },
            {
                internalType: "address",
                name: "_router",
                type: "address",
            },
            {
                internalType: "address",
                name: "_ism",
                type: "address",
            },
        ],
        name: "getDeployedInterchainAccount",
        outputs: [
            {
                internalType: "contract OwnableMulticall",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint32",
                name: "_origin",
                type: "uint32",
            },
            {
                internalType: "bytes32",
                name: "_owner",
                type: "bytes32",
            },
            {
                internalType: "bytes32",
                name: "_router",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "_ism",
                type: "address",
            },
        ],
        name: "getDeployedInterchainAccount",
        outputs: [
            {
                internalType: "contract OwnableMulticall",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint32",
                name: "_origin",
                type: "uint32",
            },
            {
                internalType: "address",
                name: "_owner",
                type: "address",
            },
            {
                internalType: "address",
                name: "_router",
                type: "address",
            },
            {
                internalType: "address",
                name: "_ism",
                type: "address",
            },
        ],
        name: "getLocalInterchainAccount",
        outputs: [
            {
                internalType: "contract OwnableMulticall",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint32",
                name: "_origin",
                type: "uint32",
            },
            {
                internalType: "bytes32",
                name: "_owner",
                type: "bytes32",
            },
            {
                internalType: "bytes32",
                name: "_router",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "_ism",
                type: "address",
            },
        ],
        name: "getLocalInterchainAccount",
        outputs: [
            {
                internalType: "contract OwnableMulticall",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint32",
                name: "_destination",
                type: "uint32",
            },
            {
                internalType: "address",
                name: "_owner",
                type: "address",
            },
        ],
        name: "getRemoteInterchainAccount",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_owner",
                type: "address",
            },
            {
                internalType: "address",
                name: "_router",
                type: "address",
            },
            {
                internalType: "address",
                name: "_ism",
                type: "address",
            },
        ],
        name: "getRemoteInterchainAccount",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint32",
                name: "_origin",
                type: "uint32",
            },
            {
                internalType: "bytes32",
                name: "_sender",
                type: "bytes32",
            },
            {
                internalType: "bytes",
                name: "_message",
                type: "bytes",
            },
        ],
        name: "handle",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [],
        name: "hook",
        outputs: [
            {
                internalType: "contract IPostDispatchHook",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_customHook",
                type: "address",
            },
            {
                internalType: "address",
                name: "_interchainSecurityModule",
                type: "address",
            },
            {
                internalType: "address",
                name: "_owner",
                type: "address",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "interchainSecurityModule",
        outputs: [
            {
                internalType: "contract IInterchainSecurityModule",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint32",
                name: "",
                type: "uint32",
            },
        ],
        name: "isms",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "localDomain",
        outputs: [
            {
                internalType: "uint32",
                name: "",
                type: "uint32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "mailbox",
        outputs: [
            {
                internalType: "contract IMailbox",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint32",
                name: "_destination",
                type: "uint32",
            },
            {
                internalType: "bytes",
                name: "_messageBody",
                type: "bytes",
            },
            {
                internalType: "uint256",
                name: "gasLimit",
                type: "uint256",
            },
        ],
        name: "quoteGasPayment",
        outputs: [
            {
                internalType: "uint256",
                name: "_gasPayment",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint32",
                name: "_destination",
                type: "uint32",
            },
        ],
        name: "quoteGasPayment",
        outputs: [
            {
                internalType: "uint256",
                name: "_gasPayment",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint32",
                name: "_domain",
                type: "uint32",
            },
        ],
        name: "routers",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_hook",
                type: "address",
            },
        ],
        name: "setHook",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_module",
                type: "address",
            },
        ],
        name: "setInterchainSecurityModule",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint32",
                name: "_domain",
                type: "uint32",
            },
        ],
        name: "unenrollRemoteRouter",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint32[]",
                name: "_domains",
                type: "uint32[]",
            },
        ],
        name: "unenrollRemoteRouters",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
export class InterchainAccountRouter__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(_mailbox, overrides) {
        return super.deploy(_mailbox, overrides || {});
    }
    getDeployTransaction(_mailbox, overrides) {
        return super.getDeployTransaction(_mailbox, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static bytecode = _bytecode;
    static abi = _abi;
    static createInterface() {
        return new utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi, signerOrProvider);
    }
}
//# sourceMappingURL=InterchainAccountRouter__factory.js.map